import { SLUG_SPORTS, SPORT_TYPES } from '~/constants'
import type { SportGameItem, MatchData } from '~/utils/interface'

export const getSportGames: () => SportGameItem[] = () => {
  const config = useRuntimeConfig()
  const SPORT_ENABLES = config.public?.SPORT_ENABLES ?? ''

  return [
    {
      id: 1,
      link: `/${SLUG_SPORTS.K_SPORTS}`,
      alias: 'K-Sports',
      imageUrl: '/assets/images/sports/k-sports-v3.webp',
      imageUrlMobile: '/assets/images/sports/k-sports-mobile-v3.webp',
      loginRequired: false,
      newTab: false,
      label: 'Hot',
      imgLabel: '/assets/images/sports/label-hot.webp',
      labelMaintance: '/assets/images/sports/label-maintance.png',
      isMaintain: !SPORT_ENABLES.includes(SPORT_TYPES.K_SPORTS)
    },
    {
      id: 2,
      link: config.public.INDIRECT_BRAND_URL ?? '',
      alias: 'B88-Sports',
      gameId: SPORT_TYPES.B88_SPORTS,
      imageUrl: '/assets/images/sports/bong88-sports-v3.webp',
      imageUrlMobile: '/assets/images/sports/bong88-sports-mobile-v3.webp',
      loginRequired: false,
      newTab: true,
      label: 'Đại lý',
      isAgency: true,
      imgLabel: '/assets/images/sports/label-agency.png',
      labelMaintance: '/assets/images/sports/label-maintance.png',
      isMaintain: !SPORT_ENABLES.includes(SPORT_TYPES.B88_SPORTS)
    },
    {
      id: 3,
      link: config.public.INDIRECT_BRAND2_URL ?? '',
      alias: 'BONGK-Sports',
      gameId: SPORT_TYPES.BONGK_SPORTS,
      imageUrl: '/assets/images/sports/bongk-sports-v2.webp',
      imageUrlMobile: '/assets/images/sports/bongk-sports-mobile-v2.webp',
      loginRequired: false,
      newTab: true,
      label: 'Đại lý',
      isAgency: true,
      imgLabel: '/assets/images/sports/label-agency.png',
      labelMaintance: '/assets/images/sports/label-maintance.png',
      isMaintain: !SPORT_ENABLES.includes(SPORT_TYPES.BONGK_SPORTS)
    },
    {
      id: 4,
      link: `/${SLUG_SPORTS.C_SPORTS}`,
      alias: 'C-Sports',
      gameId: SPORT_TYPES.C_SPORTS,
      imageUrl: '/assets/images/sports/c-sports-v2.webp',
      imageUrlMobile: '/assets/images/sports/c-sports-mobile-v2.webp',
      loginRequired: false,
      newTab: false,
      label: '',
      imgLabel: '',
      labelMaintance: '/assets/images/sports/label-maintance.png',
      isMaintain: !SPORT_ENABLES.includes(SPORT_TYPES.C_SPORTS)
    },
    {
      id: 5,
      link: `/${SLUG_SPORTS.A_SPORTS}`,
      alias: 'A-Sports',
      gameId: SPORT_TYPES.A_SPORTS,
      loginRequired: false,
      imageUrl: '/assets/images/sports/a-sports-v2.webp',
      imageUrlMobile: '/assets/images/sports/a-sports-mobile-v2.webp',
      newTab: false,
      label: '',
      imgLabel: '',
      labelMaintance: '/assets/images/sports/label-maintance.png',
      isMaintain: !SPORT_ENABLES.includes(SPORT_TYPES.A_SPORTS)
    },
    {
      id: 6,
      link: `/${SLUG_SPORTS.M_SPORTS}`,
      alias: 'P-Sports',
      gameId: SPORT_TYPES.P_SPORTS,
      imageUrl: '/assets/images/sports/p-sports-v2.webp',
      imageUrlMobile: '/assets/images/sports/p-sports-mobile-v2.webp',
      loginRequired: false,
      newTab: false,
      label: '',
      imgLabel: '',
      labelMaintance: '/assets/images/sports/label-maintance.png',
      isMaintain: !SPORT_ENABLES.includes(SPORT_TYPES.P_SPORTS)
    },
    {
      id: 7,
      link: `/${SLUG_SPORTS.E_SPORTS}`,
      alias: 'E-Sports',
      gameId: SPORT_TYPES.E_SPORTS,
      imageUrl: '/assets/images/sports/e-sports-v2.webp',
      imageUrlMobile: '/assets/images/sports/e-sports-mobile-v2.webp',
      loginRequired: true,
      newTab: false,
      label: '',
      imgLabel: '',
      labelMaintance: '/assets/images/sports/label-maintance.png',
      isMaintain: !SPORT_ENABLES.includes(SPORT_TYPES.E_SPORTS)
    },
    {
      id: 8,
      link: `/${SLUG_SPORTS.V_SPORTS}`,
      alias: 'V-Sports',
      gameId: SPORT_TYPES.VIRTUAL_SPORTS,
      imageUrl: '/assets/images/sports/v-sports-v2.webp',
      imageUrlMobile: '/assets/images/sports/v-sports-mobile-v2.webp',
      loginRequired: true,
      newTab: false,
      label: '',
      imgLabel: '',
      labelMaintance: '/assets/images/sports/label-maintance.png',
      isMaintain: !SPORT_ENABLES.includes(SPORT_TYPES.VIRTUAL_SPORTS)
    },
    {
      id: 9,
      link: '/the-thao/lich-thi-dau',
      alias: 'lich-thi-dau',
      imageUrl: '/assets/images/sports/lich-thi-dau-mobile-v2.webp',
      imageUrlMobile: '/assets/images/sports/lich-thi-dau-mobile-v2.webp',
      loginRequired: false,
      newTab: false,
      isMaintain: false,
      label: '',
      imgLabel: '',
      isHideOnDesktop: true,
      isComingSoon: false,
      labelMaintance: '/assets/images/sports/label-maintance.png',
      labelComingSoon: '/assets/images/sports/label-coming-soon.png'
    }
  ]
}
export const hotmatchNoDataItem: MatchData = {
  teams: [
    {
      name: 'Đang cập nhật',
      flag_thumbnail: ''
    },
    {
      name: 'Đang cập nhật',
      flag_thumbnail: ''
    }
  ],
  league_name: 'Giải đấu đang cập nhật',
  league_id: '',
  text_time: '',
  match_id: '',
  isDisable: true,
  league_name_text: '',
  league_image: '',
  athena_league_id: '',
  athena_match_id: ''
}
